module.exports = __webpack_public_path__ + "img/turtle.be5030ca.webp";